import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useConfirmTwoFactor } from '@services/global/twoFactor/confirm';
import { ConfirmTwoFactorResp } from '@services/global/twoFactor/confirm';

export const useConfirmTwoFactorForm = ({
  handleSuccess,
}: {
  handleSuccess: (data: ConfirmTwoFactorResp) => void;
}) => {
  const { t } = useTranslation('app');

  const schema = z.object({
    otpCode: z
      .string()
      .trim()
      .min(1, { message: t('form.otpCode.required') })
      .min(6, { message: t('form.otpCode.length') }),
  });

  const defaultValues = {
    otpCode: '',
  };

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues,
  });

  const { mutate, isPending, error } = useConfirmTwoFactor({ handleSuccess });

  const onSubmit = async (values: z.infer<typeof schema>) => {
    mutate(values);
  };

  return {
    form,
    onSubmit,
    isPending,
    error,
  };
};
